const GAME_OBJECTS = {

    desk: {
        id: "desk",
        interactive: false,
        status: {
            default: "/images/game/chapter1/game-objects/min-desk.png",
        },
        position: {
            x: 0,
            y: 770
        },
        size: {
            width: 1508,
            height: 310,
        },
        image: null,
        name: null,
        title: null,
        description: null,
    },
    door: {
        id: "door",
        number: 1,
        stars: 4,
        image: "/images/game/chapter1/game-objects/min-door.png",
        status: {
            default: "/images/game/chapter1/game-objects/min-door.png",
            done: "/images/game/chapter1/game-objects/min-door-done.png",
        },
        position: {
            x: 1377,
            y: 369
        },
        size: {
            width: 271,
            height: 443,
        },
        name: "大門",
        title: "和鄰居/族人見面",
        description: "聯絡感情的同時也要定期更新防災資訊。",
        importance: "平時多互動，災害來時可互相幫助，資訊流通更快。",
    },
    calendar: {
        id: "calendar",
        position: {
            x: 405,
            y: 123
        },
        size: {
            width: 195,
            height: 245,
        },
        status: {
            default: "/images/game/chapter1/game-objects/min-calendar.png",
            done: "/images/game/chapter1/game-objects/min-calendar-done.png",
        },
        number: 2,
        stars: 3,
        image: "/images/game/chapter1/game-objects/min-calendar.png",
        name: "日曆",
        title: "規劃防災演練日",
        description: "為可能發生的災害做準備",
        importance: "透過演練熟悉應變流程，災害來時較不會慌亂。",
    },
    plant: {
        id: "plant",
        number: 6,
        status: {
            default: "/images/game/chapter1/game-objects/min-flower.png",
            done: "/images/game/chapter1/game-objects/min-flower-done.png",
        },
        position: {
            x: 1655,
            y: 475
        },
        size: {
            width: 253,
            height: 351,
        },
        image: "/images/game/chapter1/game-objects/min-flower.png",
        name: "花盆",
        title: "跟花說「你是不是花美男」",
        description: "聽說帥哥都很害羞…",
    },
    radio: {
        id: "radio",
        number: 7,
        stars: 5,
        status: {
            default: "/images/game/chapter1/game-objects/min-radio.png",
            done: "/images/game/chapter1/game-objects/min-radio-done.png",
        },
        position: {
            x: 148,
            y: 704
        },
        size: {
            width: 275,
            height: 195,
        },
        image: "/images/game/chapter1/game-objects/min-radio.png",
        name: "收音機",
        title: "收聽新聞廣播",
        description: "來聽聽最近都發生了什麼",
        importance: "即時掌握災害資訊，隨時調整因應方式。",
    },
    paperPlane: {
        id: "paperPlane",
        number: 8,
        status: {
            default: "/images/game/chapter1/game-objects/min-paperplane.png",
            done: "/images/game/chapter1/game-objects/min-paperplane-done.png",
        },
        position: {
            x: 1297,
            y: 815
        },
        size: {
            width: 111,
            height: 70,
        },
        image: "/images/game/chapter1/game-objects/min-paperplane.png",
        name: "紙飛機",
        title: "丟紙飛機",
        description: "會不會飛到長頸鹿的頭上",
    },
    window: {
        id: "paperPlane",
        number: 8,
        status: {
            default: "/images/game/chapter1/game-objects/min-window.png",
            done: "/images/game/chapter1/game-objects/min-window-done.png",
        },
        position: {
            x: 32,
            y: 119
        },
        size: {
            width: 347,
            height: 536,
        },
        image: "/images/game/chapter1/game-objects/min-window.png",
        name: "紙飛機",
        title: "丟紙飛機",
        description: "會不會飛到長頸鹿的頭上",
    },
    map: {
        id: "map",
        number: 4,
        stars: 5,
        status: {
            default: "/images/game/chapter1/game-objects/min-map.png",
            done: "/images/game/chapter1/game-objects/min-map-done.png",
        },
        position: {
            x: 1656,
            y: 270
        },
        size: {
            width: 194,
            height: 144,
        },
        image: "/images/game/chapter1/game-objects/min-map.png",
        name: "地圖",
        title: "瞭解避難場所與路線",
        description: "看一眼，不會花太多時間",
        importance: "熟悉避難地點與逃生路線，緊急時更快撤離確保安全。",
    },
    photo: {
        id: "photo",
        number: 5,
        status: {
            default: "/images/game/chapter1/game-objects/min-photo.png",
            done: "/images/game/chapter1/game-objects/min-photo-done.png",
        },
        position: {
            x: 804,
            y: 177
        },
        size: {
            width: 531,
            height: 315,
        },
        image: "/images/game/chapter1/game-objects/min-photo.png",
        name: "照片",
        title: "重新擺設照片",
        description: "風水不好 錢財不保",
    },
    clock: {
        id: "clock",
        requiresPreparation: true,
        status: {
            default: "/images/game/chapter1/game-objects/min-clock.png",
            done: "/images/game/chapter1/game-objects/min-clock.png",
        },
        position: {
            x: 586,
            y: 271
        },
        size: {
            width: 192,
            height: 222,
        },
        number: 3,
        image: "/images/game/chapter1/game-objects/min-clock.png",
        name: "時鐘",
        title: "時鐘",
        description: "隨時知道自己活在幾時幾分相當重要。",
    },

};

export default GAME_OBJECTS;